module.exports = __webpack_public_path__ + "static/img/smart2.5788d46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/smart/smart2.jpg
// module id = AzP2
// module chunks = 1